import {useContext} from 'react'

import AnalyticsV2Context from './useAnalyticsContext'
import useIsAnalyticsV2Avail from './useIsAnalyticsV2Available'

export const useAnalyticsV2 = () => {
  const analytics = useContext(AnalyticsV2Context)
  const isAnalyticsV2Available = useIsAnalyticsV2Avail()

  if (!analytics) {
    if (!isAnalyticsV2Available)
      return {
        implementations: [],
        enabled: false,
        initAll: async () => {},
        setUserIdAll: async () => {},
        trackEventAsDefaultOnInternal: async () => {},
        trackEventOnAll: async () => {},
        trackScreenViewAll: async () => {},
        trackProductViewOnAll: async () => {},
        trackAddToCartOnAll: async () => {},
        trackInitCheckoutOnAll: async () => {},
        trackPurchaseOnAll: async () => {},
      }
    throw new Error('useAnalyticsV2 must be used within an AnalyticsV2Provider')
  }
  return analytics
}
